export enum RolesEnum {
  admin = 'POPL.Admin',
  analyst = 'POPL.Analista',
  operator = 'POPL.Operador',
  preOperator = 'POPL.Pré-Operador',
}
